module.exports = __webpack_public_path__ + "img/medicine.8ccdb74a.jpg";